// Pure helpers for configurator basket bookkeeping. Operate on plain arrays
// and metadata so they can be unit-tested without mounting the App component.

// Returns ItemProperty entries (under parents that are themselves in `selected`)
// whose Name matches the provided property's Name. Gating by parent membership
// keeps mirrors like `hardware.Profiles.HardwareModel` out of the basket
// unless the user explicitly picked `hardware.Profiles`.
export function getRelatedProperties(property, selected, allProperties) {
    var result = [];
    var propsWithSubProps = allProperties.filter(p =>
        p.ItemProperties && p.ItemProperties.length > 0
        && selected.indexOf(p.Id) !== -1);
    propsWithSubProps.forEach((p) => {
        p.ItemProperties.forEach((s) => {
            if (property.Name === s.Name) {
                result.push(s);
            }
        });
    });
    return result;
}

// Returns a new array containing `properties` plus `propertyId` and any
// related entries (dependencies and mirror entries under a selected parent).
// Pure: does not mutate input arrays.
export function addProperty(propertyId, properties, allProperties) {
    var propertyMetaData = allProperties.find(e => e.Id === propertyId);
    if (!propertyMetaData || properties.indexOf(propertyMetaData.Id) !== -1) {
        return properties;
    }

    var joined = properties.concat(propertyMetaData.Id);

    if (propertyMetaData.Dependencies) {
        propertyMetaData.Dependencies.forEach((d) => {
            if (joined.indexOf(d) === -1) {
                joined = addProperty(d, joined, allProperties);
            }
        });
    }

    if (propertyMetaData.ItemProperties &&
        propertyMetaData.ItemProperties.length > 0) {
        // Parent (e.g. hardware.Profiles): backfill a mirror entry for every
        // sibling already in the basket.
        propertyMetaData.ItemProperties.forEach((ip) => {
            var siblingSelected = joined.some((id) => {
                var p = allProperties.find(s => s.Id === id);
                return p && p.Name === ip.Name;
            });
            if (siblingSelected && joined.indexOf(ip.Id) === -1) {
                joined = joined.concat(ip.Id);
            }
        });
    } else {
        var duplicateProperties = getRelatedProperties(
            propertyMetaData, joined, allProperties);
        duplicateProperties.forEach((p) => {
            if (joined.indexOf(p.Id) === -1) {
                joined = joined.concat(p.Id);
            }
        });
    }

    return joined;
}

// Returns a new array of `properties` with `propertyId` and any mirror entries
// that should follow it removed. Pure: does not mutate input arrays.
export function removeProperty(propertyId, properties, allProperties) {
    var result = properties.filter(p => p !== propertyId);
    var propertyMetaData = allProperties.find(e => e.Id === propertyId);
    if (!propertyMetaData) {
        return result;
    }

    if (propertyMetaData.ItemProperties &&
        propertyMetaData.ItemProperties.length > 0) {
        // Parent removed: drop every mirror entry that lived under it,
        // regardless of sibling selection.
        var ids = propertyMetaData.ItemProperties.map(ip => ip.Id);
        return result.filter(p => ids.indexOf(p) === -1);
    }

    var duplicateProperties = getRelatedProperties(
        propertyMetaData, result, allProperties);
    var dupIds = duplicateProperties.map(p => p.Id);
    return result.filter(p => dupIds.indexOf(p) === -1);
}
